$(function() {
  // filter
  $('.collection-product-v2-filters .collection-filter-header').on('click', function() {
    $(this).toggleClass('active');
  });
  $('.collection-product-v2-filters-toggle, .collection-product-v2-filters-close').on('click', function() {
    $('.collection-product-v2-filters').toggleClass('active');
    $('.collection-product-v2-products').toggleClass('active');
  });

  // view, sort
  var new_params = new URLSearchParams(window.location.search),
      select_els = $('.collection-product-v2-sorts #view, .collection-product-v2-sorts #sort_by');

  select_els.each(function() {
    var name = $(this).attr('name')
    if (new_params.has(name)) {
      var val = new_params.get(name);
      $(this).val(val);
    }
  });

  select_els.on('change', function() {
    new_params.set($(this).attr('name'), $(this).val());

    window.location.href = window.location.pathname + '?' + new_params.toString();
  });

  // products
  $('.collection-product-v2-products .product-card-image-nav button').on('click', function() {
    var action = $(this).data('action');
    var card = $(this).parent().prev('.product-card');
    var img = card.find('.product-card-image.main');
    var imgs = card.find('.product-card-image');

    var img_main = action == 'prev' ? img.prev() : img.next();
    if (img_main.length == 0) {
      img_main = action == 'prev' ? imgs.last() : imgs.first();
    } else {
    }

    var img_secondary = img_main.next();
    if (img_secondary.length == 0) {
      img_secondary = imgs.first();
    }

    imgs.removeClass('main');
    imgs.removeClass('secondary');
    img_main.addClass('main');
    img_secondary.addClass('secondary');
  });

  function updateProductCardImageHeight() {
    var key = '--product-card-image-height';
    var value = $('.collection-product-v2-products .product-card-image-container').outerHeight();
    // document.getElementsByClassName('collection-product-v2-products').style.setProperty(key, `${value}px`);
    document.body.style.setProperty(key, `${value}px`);
  }
  updateProductCardImageHeight();
  $(window).on('load scroll resize orientationchange', updateProductCardImageHeight);
});